import React, { Fragment, Component } from "react";
import ActionDelete from "@material-ui/icons/Delete";
import { Button, Confirm, withDataProvider } from "react-admin";
import compose from "recompose/compose";
import { createStyles, withStyles } from "@material-ui/core/styles";
import { fade } from "@material-ui/core/styles/colorManipulator";
import { hasPatientToken } from "../../redux/patients/selectors";
import { connect } from "react-redux";
import { Checkbox, FormControlLabel, FormGroup } from "@material-ui/core";
import { crudDeleteWithChecked } from "./actions";

const styles = (theme) =>
  createStyles({
    deleteButton: {
      color: theme.palette.error.main,
      "&:hover": {
        backgroundColor: fade(theme.palette.error.main, 0.12),
        // Reset on mouse devices
        "@media (hover: none)": {
          backgroundColor: "transparent",
        },
      },
    },
  });

class DeleteConfirmButton_ extends Component {
  state = { isOpen: false, checked: false };

  handleChangeCheckbox = (e) => {
    this.setState({ checked: e.target.checked });
  };

  handleClick = () => {
    this.setState({ isOpen: true });
  };

  handleDialogClose = () => {
    this.setState({ isOpen: false });
  };

  handleConfirm = () => {
    this.setState({ isOpen: false });
    const id = this.props.record.id;
    const checked = this.state.checked;
    const { resource, basePath, dispatchCrudDelete } = this.props;
    dispatchCrudDelete(resource, id, checked, basePath, true, "list");
  };

  getConfirmContent = () => {
    const { hasPatientToken } = this.props;
    if (hasPatientToken === false) {
      return "Are you sure want to remove this patient ?";
    }

    return (
      <FormGroup>
        <FormControlLabel
          control={<Checkbox onChange={this.handleChangeCheckbox} />}
          label="Remove the patient from PowerDot Consumer database too"
        />
      </FormGroup>
    );
  };

  getConfirm = () => {
    if (this.state.isOpen) {
      return (
        <Confirm
          isOpen={this.state.isOpen}
          title="Remove Patient"
          content={this.getConfirmContent()}
          onConfirm={this.handleConfirm}
          onClose={this.handleDialogClose}
        />
      );
    }
    return null;
  };

  render() {
    return (
      <Fragment>
        <Button
          label="Delete"
          onClick={this.handleClick}
          icon={<ActionDelete />}
          className={this.props.classes.deleteButton}
        />
        {this.getConfirm()}
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  hasPatientToken: hasPatientToken(state, ownProps),
});

const DeleteConfirmButton = compose(
  connect(mapStateToProps, { dispatchCrudDelete: crudDeleteWithChecked }),
  withStyles(styles)
)(DeleteConfirmButton_);

export default withDataProvider(DeleteConfirmButton);
